var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 7.5C2.625 5.02513 2.625 3.78769 3.39385 3.01885C4.16269 2.25 5.40013 2.25 7.875 2.25H10.125C12.5998 2.25 13.8373 2.25 14.6062 3.01885C15.375 3.78769 15.375 5.02513 15.375 7.5V11.25C15.375 13.7248 15.375 14.9623 14.6062 15.7312C13.8373 16.5 12.5998 16.5 10.125 16.5H7.875C5.40013 16.5 4.16269 16.5 3.39385 15.7312C2.625 14.9623 2.625 13.7248 2.625 11.25V7.5Z",
    stroke: "#626F86",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25H9M6 7.5H12",
    stroke: "#626F86",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/Description.8f2aca6f5b8d41ab1c9440c4a780ef37.svg";
export { ForwardRef as ReactComponent };